
import CryptoJS from 'crypto-js'

/**
  * AES加密
  * @param {any} word 加密数据
  */
export const Encrypt = (word) => {
  const key = CryptoJS.enc.Utf8.parse('6T9b9hcktB4V8q3m')
  const iv = CryptoJS.enc.Utf8.parse('de34567887654321')
  let encrypted = ''
  let srcs = ''
  if (typeof (word) === 'string') {
    srcs = word
  } else if (typeof (word) === 'object') { // 对象格式的转成json字符串
    srcs = CryptoJS.enc.Utf8.parse(word)
  }
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}

/**
  * AES解密
  * @param {any} word 解密数据
  */
export const Decrypt = (word) => {
  const key = CryptoJS.enc.Utf8.parse('6T9b9hcktB4V8q3m')
  const iv = CryptoJS.enc.Utf8.parse('de34567887654321')
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js